export default __webpack_public_path__ + "static/media/search_no_result.b2694b2a.gif";